<!-- 人工校准表单 -->
<template>
  <el-form ref="formRef" label-position="top" label-width="auto" :model="formData" :rules="rules">
    <el-form-item label="人工判定质量结果" prop="staffRiskStatus">
      <el-radio-group v-model="formData.staffRiskStatus">
        <el-radio :value="1">疑似风险</el-radio>
        <el-radio :value="0">无风险</el-radio>
        <el-radio :value="2">无效</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="人工判定质量分析说明" prop="staffRiskResult">
      <el-input
        v-model="formData.staffRiskResult"
        placeholder="请输入"
        :rows="15"
        type="textarea"
      />
    </el-form-item>
  </el-form>
</template>

<script setup>
import { ref, reactive } from 'vue'

const props = defineProps({
  // 初始分析信息
  riskInfo: {
    type: Object,
    default: () => ({
      riskResult: '',
      riskStatus: 0
    })
  }
})

const formRef = ref()
// 表单数据
const formData = reactive({
  staffRiskStatus: props.riskInfo.riskStatus,
  staffRiskResult: props.riskInfo.riskResult
})
// 表单校验规则
const rules = reactive({
  staffRiskStatus: [{ required: true, message: '请选择', trigger: 'blur' }],
  staffRiskResult: [{ required: true, message: '请输入', trigger: 'blur' }]
})

defineExpose({
  formRef,
  formData
})
</script>

<style lang="scss" scoped>
:deep(.el-radio__input.is-checked .el-radio__inner) {
  background-color: #7a52f4;
  border-color: #7a52f4;
}
:deep(.el-radio__input.is-checked + .el-radio__label) {
  font-size: 14px;
  color: #323233;
}
</style>
